import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import SquaberLink from "../../../SquaberLink";

const Breadcrumb = ({
  children,
  href,
  className,
  disabled,
  target,
  onClick,
  ...rest
}) => {
  const linkClassName = classNames(
    "text-xs",
    "font-medium",
    "line-height-100",
    "text-link",
    "no-underline",
    "hover:text-link-dark",
    "focus-visible:outline-link",
    "active:opacity-85",
    {
      "text-link_disabled": disabled
    },
    className
  );

  if (!href) {
    return (
      <span className={linkClassName} {...rest}>
        {children}
      </span>
    );
  }

  return (
    <SquaberLink
      to={href}
      target={target}
      className={linkClassName}
      aria-disabled={disabled || undefined}
      onClick={
        disabled
          ? event => {
              event.preventDefault();
            }
          : onClick
      }
      {...rest}
    >
      {children}
    </SquaberLink>
  );
};

Breadcrumb.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  target: PropTypes.string,
  onClick: PropTypes.func
};

export default Breadcrumb;
